import { useEffect, useState } from 'react';
import { Send } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
  ArrowRight,
  BadgeCheck,
  Calendar,
  CheckCircle2,
  ChevronDown,
  CircleDollarSign,
  Code2,
  GraduationCap,
  Layers,
  LineChart,
  Link2,
  Menu,
  Rocket,
  Sparkles,
  Target,
  Users,
  X,
} from 'lucide-react';

export const C = {
  ink: '#0b1f3a',
  inkSoft: '#334155',
  muted: '#64748b',
  line: '#e2e8f0',
  bg: '#ffffff',
  bgSoft: '#f8fafc',
  bgTint: '#f1f5f9',
  accent: '#1d4ed8',
  accentDeep: '#1e3a8a',
  accentSoft: '#eff6ff',
  card: '#ffffff',
};

const PROGRAM_STRUCTURE = [
  { icon: Users, label: 'Eligibility', value: 'All Tech Job Aspirants [2022 - 2026]' },
  { icon: Calendar, label: 'Screening Period', value: 'Before 31st July 2026 (Apply only with Confirmation Investment)' },
  { icon: Rocket, label: 'Onboarding Start From', value: 'August 2026' },
  { icon: CircleDollarSign, label: 'Monthly Salary', value: 'IDR 4.669.903 – 5.603.884 per month' },
  { icon: GraduationCap, label: 'Training & Certification Investment', value: 'Mandatory Certification Investment INR 2,50,000 (Instructor-led training + globally recognized Dual Certification on Infor Cloud Suite – ERP + MES Industry 4.0). This investment is mandatory for all selected candidates as part of the project requirements.' },
];

const LOOKING_FOR = [
  { icon: Code2, text: '0–2 years of experience in software development using C#, SQL, .NET, or Java.' },
  { icon: Users, text: 'All Tech Job aspirants: B.Tech freshers and early-career professionals.' },
  { icon: Calendar, text: 'Must be willing to join immediately, Remote working options are available.' },
  { icon: CircleDollarSign, text: 'Only apply if you are comfortable with an initial starting salary of IDR 78,500,000 per year' },
];

const IMPORTANT_INFO = [
  { icon: Target, label: 'Why It Is Mandatory', value: 'This dual certification is a mandatory requirement for current and upcoming Infor support projects.' },
  { icon: Users, label: 'Job Aspirants\'s Responsibility', value: 'As we handle employee salaries and other benefits, certifications are entirely the job aspirant\'s responsibility. Job aspirants are requested to associate with a suitable training company for certification purposes.' },
  { icon: Sparkles, label: 'Ownership & Career Benefit', value: 'These certifications are earned in the individual\'s name and remain with them throughout their career, adding long-term value to their professional profile.' },
  // { icon: BadgeCheck, label: 'Self-Investment Requirement', value: 'There is a mandatory self-investment of ₹ 2,50,000 required for the dual certification (ERP + MES Smart Manufacturing), which the employee needs to bear.' },
];

export default function Structure() {
  return (
    <section id="structure" className="relative" style={{ backgroundColor: '#ffffff' }}>
      <div className="absolute inset-0 paper-grain opacity-50" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Two-column cards below the image */}
        <div className="grid lg:grid-cols-2 gap-8">
          {/* Left - Looking For */}
          <div className="rounded-2xl p-7 sm:p-9" style={{ backgroundColor: C.card, border: `1px solid ${C.line}` }}>
            <div className="space-y-6">
            <h3 className="text-xl font-semibold mb-6" style={{ color: C.ink }}>Important – Certification Mandatory</h3>
              {IMPORTANT_INFO.map((s, i) => (
                <div key={s.label} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div
                      className="h-10 w-10 rounded-full flex items-center justify-center shrink-0"
                      style={{ backgroundColor: '#0D5EF4', color: '#ffffff' }}
                    >
                      <s.icon className="w-5 h-5" />
                    </div>
                    {i !== IMPORTANT_INFO.length - 1 && (
                      <div className="w-px flex-1 mt-2" style={{ backgroundColor: C.line }} />
                    )}
                  </div>
                  <div className="pb-2">
                    <div className="text-xs uppercase tracking-wider font-semibold" style={{ color: '#0D5EF4' }}>
                      {s.label}
                    </div>
                    <div className="font-medium mt-1" style={{ color: C.ink }}>
                      {s.value}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Important Mandatory Information */}
          <div className="rounded-2xl p-7 sm:p-9" style={{ backgroundColor: C.card, border: `1px solid ${C.line}` }}>
            <h3 className="text-xl font-semibold mb-6" style={{ color: C.ink }}>What We Are Looking For</h3>
            <ul className="space-y-5">
              {LOOKING_FOR.map((l) => (
                <li key={l.text} className="flex gap-4">
                  <div
                    className="shrink-0 h-9 w-9 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: '#0D5EF4', color: '#ffffff' }}
                  >
                    <l.icon className="w-4 h-4" />
                  </div>
                  <span className="font-medium mt-1" style={{ color: C.ink }}>{l.text}</span>
                </li>
              ))}
              <div className='flex items-center gap-10 pt-6'>
              <h1 className="text-2xl font-semibold" style={{ color: '#0D5Ef4' }}>Are You Ready?</h1>
                <Link onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                to="/career/infor-cloud-suite-bootcamp/apply"
                className="bg-[#0D5EF4] hover:bg-[#004b82]
                text-white font-semibold px-10 py-4
                transition-all duration-300"
              >
                Apply Now
              </Link>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}